export default __webpack_public_path__ + "static/photo-bar-4-62e4a57e3a22e91b4aa90c8cf69db390.jpg";